import NewLayout from "@components/new-ui/Layout";
import { CompanyTrustBanner } from "@components/Webinar/CompanyTrustBanner";
import IndividualWebinar, { IndividualWebinarProps } from "@components/Webinar/IndividualWebinar";

const HeroSectionData: IndividualWebinarProps = {
    title: "Why 60% of real estate leads never close and how to fix it in 30 days?",
    listHeading: `Some real estate brands seem unstoppable — deals closed in days, site visits packed, no lead slipping through the cracks.
        Others? Still chasing callbacks and waiting for emails that never come.`,
    listText: [
        { label: "Responding to every lead in seconds automatically" },
        { label: "Turning “just browsing” prospects into booked visits with smart nudges" },
        { label: "Keeping sales teams perfectly in sync (no more Excel chaos)" },
        { label: "Building real buyer relationships instead of blasting generic messages" },
    ],
    mediaUrl: "https://assets.gallabox.com/gb-home/webinar/webinar-9.png",
    speakerList: [
        {
            image: "/karthik.png",
            name: "Karthik J",
            role: "CEO, Gallabox",
        },
        {
            image: "/vidhya.png",
            name: "Vidhya S",
            role: "Whatsapp Evangelist",
        },
    ],
    youtubeURL: "https://youtu.be/PP6-IqmeLVU",
    inThisWebinar: "In this session, we'll show you exactly how the fastest-growing developers and brokers are:",
    webinarSlug: "webinars/why-60-percent-real-estate-leads-never-close",
};

const Webinar: React.FC = () => {
    return (
        <NewLayout
            title="Why 60% of real estate leads never close and how to fix it in 30 days?"
            description="Discover why 60% of real estate leads never close — and how you can fix it in just 30 days with smart WhatsApp automation."
            canonical="https://gallabox.com/webinars/why-60-percent-real-estate-leads-never-close"
            ogAttributes={{ image: "https://assets.gallabox.com/gb-home/webinar/webinar-9.png" }}
        >
            <IndividualWebinar {...HeroSectionData} />
            <CompanyTrustBanner />
        </NewLayout>
    );
};

export default Webinar;
